import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem('ib_theme') || 'dark');
  const [textSize, setTextSizeState] = useState(() => localStorage.getItem('ib_text_size') || 'normal');

  const setTheme = (t) => {
    setThemeState(t);
    localStorage.setItem('ib_theme', t);
  };

  const setTextSize = (s) => {
    setTextSizeState(s);
    localStorage.setItem('ib_text_size', s);
  };

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
    root.setAttribute('data-text-size', textSize);
  }, [theme, textSize]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, textSize, setTextSize }}>
      {children}
    </ThemeContext.Provider>
  );
}
